import { render } from "./edit_banks.vue?vue&type=template&id=56ebb746"
import script from "./edit_banks.vue?vue&type=script&lang=js"
export * from "./edit_banks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__